<template>
  <div class="ma-4">
    <v-app-bar app clipped-left dense flat>
      <v-layout>
        <v-spacer></v-spacer>
        <v-btn color="farmer_green" class="white--text" @click="onLogout()" depressed>Logout</v-btn>
      </v-layout>
    </v-app-bar>
    <v-main>
      <v-card>
        <AddAdminDialog class="pa-3" />
        <v-data-table :headers="headers" :items="admins" :page.sync="page" @page-count="pageCount = $event" hide-default-footer :items-per-page="10">
          <template v-slot:[`item.number`]="{item}">
            {{admins.indexOf(item)+1}}
          </template>
          <template v-slot:[`item.isAccountVerified`]="{item}">
            <v-icon v-if="item.isAccountVerified" color="farmer_green">verified_user</v-icon>
          </template>
          <template v-slot:[`item.creationError`]="{item}">
            <v-alert v-if="item.creationError.length > 0" type="error" dense text>{{item.creationError}}</v-alert>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-row>
              <v-icon small class="mr-2 ">
                edit
              </v-icon>
              <DeleteAdminDialog :admin="item" />
            </v-row>
          </template>
        </v-data-table>
        <v-divider></v-divider>
        <div class="text-center pt-2">
          <v-pagination v-model="page" :length="pageCount"></v-pagination>
        </div>
      </v-card>
    </v-main>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'Manager',
  components: {
    AddAdminDialog: () => import('@/components/admin/spa/AddAdminDialog'),
    DeleteAdminDialog: () => import('@/components/admin/spa/DeleteAdminDialog')
  },
  data() {
    return {
      page: 1,
      pageCount: 0,
      headers: [
        {
          text: 'N°',
          align: 'start',
          value: 'number'
        },
        { text: 'First Name', value: 'firstName' },
        { text: 'Last Name', value: 'lastName' },
        { text: 'E-mail', value: 'email' },
        { text: 'Phone Number', value: 'phoneNumber' },
        {
          text: 'Verification Status',
          align: 'center',
          value: 'isAccountVerified'
        },
        {
          text: 'Errors',
          align: 'center',
          value: 'creationError'
        },
        { text: 'Actions', value: 'actions', sortable: false }
      ]
    }
  },
  computed: {
    ...mapGetters(['admins'])
  },
  methods: {
    onLogout() {
      this.$router.push('/spa')
      this.$store.dispatch('logoutSpa')
    }
  },
  mounted() {
    this.$store.dispatch('loadAdmins')
  }
}
</script>

<style scoped>
.manager {
  margin-top: 2em;
}
</style>
